<template>
    <a-row :gutter="16">
      <a-col span="24">
        <div class="panel panel-default panel-stretch">
          <div class="panel-heading">
            Management rapportage dashboard
          </div>

          <div class="panel-body no-padding">
            <a-row>
              <a-col :span="24" style="padding: 1.5rem;">
                <ReportingTypeButton type="task" title="Taken" path="reporting.tasks" />
                <ReportingTypeButton type="mortgage" title="Hypotheken" path="reporting.mortgages" />
                <ReportingTypeButton type="policy" title="Verzekeringen" path="reporting.policies" />
              </a-col>
            </a-row>
          </div>
        </div>
      </a-col>
    </a-row>
</template>

<script>
import {Skeleton} from 'vue-loading-skeleton';
import RowComponent from "./RowComponent";
import ReportingTypeButton from '~/modules/reporting/components/ReportingTypeButton'

export default {
  name: "ReportingOverviewComponent",
  components: {
    Skeleton,
    RowComponent,
    ReportingTypeButton,
  },
}
</script>
